import React from 'react'
import { Hidden } from '@material-ui/core'
import styled from 'styled-components'
import AlertResultMobileTop from './MobileTop'
import AlertResultDesktopTop from './DesktopTop'
import GoogleMap from '../../Shared/GoogleMap'
import { Box } from '../../Shared/Base'

const StyledWrapperMap = styled.div`
  position: relative;
  width: 100%;
  margin-top: -2px;
  height: 500px;

  @media screen and (min-height: 1000px) {
    height: 600px;
  }

  @media screen and (max-height: 750px) {
    height: 350px;
  }

  @media screen and (max-width: 1129px) {
    height: 350px;
  }
`

const MobileDesktopWrapper = ({ children }) => {
  return (
    <>
      <Hidden mdUp>
        <Box width="100%">
          <Box pt="66.67%" position="relative">
            <Box top="0" position="absolute" width="100%" height="100%">
              {children}
            </Box>
          </Box>
        </Box>
      </Hidden>
      <Hidden smDown>
        <StyledWrapperMap>{children}</StyledWrapperMap>
      </Hidden>
    </>
  )
}

const AlertResultTop = ({
  navChoice,
  images,
  linkBack,
  is_favorite,
  latlng,
  address,
  og_url,
  onFavorite,
  onUnfavorite
}) => {
  switch (navChoice) {
    case 'map':
      return (
        <MobileDesktopWrapper>
          <GoogleMap latlng={latlng} />
        </MobileDesktopWrapper>
      )

    case 'streetview':
      return (
        <MobileDesktopWrapper>
          <GoogleMap address={address} type="streetview" />
        </MobileDesktopWrapper>
      )

    default:
      return (
        <>
          <Hidden mdUp>
            <AlertResultMobileTop
              images={images}
              linkBack={linkBack}
              is_favorite={is_favorite}
              onFavorite={onFavorite}
              onUnfavorite={onUnfavorite}
              og_url={og_url}
            />
          </Hidden>
          <Hidden smDown>
            <AlertResultDesktopTop
              linkBack={linkBack}
              images={images}
              is_favorite={is_favorite}
              onFavorite={onFavorite}
              onUnfavorite={onUnfavorite}
            />
          </Hidden>
        </>
      )
  }
}

export default AlertResultTop
